module.exports = __webpack_public_path__ + "img/Weapon_110.c453f42d.png";